import OrderSummary from './OrderSummary';

export default OrderSummary;